import { createEntityAdapter } from '@reduxjs/toolkit';
import { DialogMessageViewModel } from '@common/model/dialog/message/dialogMessageViewModel';

export const messagesAdapter = createEntityAdapter<DialogMessageViewModel>({
  selectId: (m) => m.id,
});
